import { useEffect, useRef } from 'react';

const useShiftSpaceListener = (handleOpenTemplate) => {
  const inputRef = useRef(null);

  useEffect(() => {
    if (handleOpenTemplate) {
      const handleKeyDown = (event) => {
        if (event.shiftKey && event.code === 'Space') {
          handleOpenTemplate();
        }
      };

      const inputElement = inputRef.current;
      if (inputElement) {
        inputElement.addEventListener('keydown', handleKeyDown);
      }

      return () => {
        if (inputElement) {
          inputElement.removeEventListener('keydown', handleKeyDown);
        }
      };
    }
  }, [handleOpenTemplate]);

  return inputRef;
};

export default useShiftSpaceListener;